import { Routes } from "@angular/router";
import { CanDeactivateGuard } from "../../core/guards/can-deactivate/can-deactivate.guard";
import { DeliveryStatusListComponent } from "./delivery-status-list/delivery-status-list.component";
import { ProductionWorkflowListingComponent } from "./production-workflow-listing/production-workflow-listing.component";
import { ProductionWorkflowSummaryComponent } from "./production-workflow-summary/production-workflow-summary.component";
import { ReassignWorkflowApprovalComponent } from "./reassign-workflow-approval/reassign-workflow-approval.component";
import { ProductionWorkflowArchivedListingComponent } from "./production-workflow-archived-listing/production-workflow-archived-listing.component";
import { ClientGroupComponent } from "./client-group/client-group.component";
import { ClientGroupDetailComponent } from "./client-group-detail/client-group-detail.component";
import { AccessApprovalComponent } from "./access-approval/access-approval.component";
import { BuyerComponent } from "./buyer/buyer.component";
import { RoleGuard } from "../../core/guards/role/role.guard";
import { UserRole } from "../../shared/enums/userRoles.enum";

export const projectWorkflowRoutes: Routes = [
  {
    path: "",
    component: ProductionWorkflowListingComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "archive",
    component: ProductionWorkflowArchivedListingComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "workflow-summary/:id",
    component: ProductionWorkflowSummaryComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "workflow-summary/:id/:salesOrderId",
    component: ProductionWorkflowSummaryComponent,
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "workflow-approval/:workflowId/:newOwner",
    component: ReassignWorkflowApprovalComponent,
  },
  {
    path: "delivery-status-and-exception",
    component: DeliveryStatusListComponent,
  },
  {
    path: "client-group",
    component: ClientGroupComponent,
  },
  {
    path: "client-group/:clientId",
    component: ClientGroupDetailComponent,
  },
  {
    path: "buyer",
    component: BuyerComponent,
  },
  {
    path: "approval",
    component: AccessApprovalComponent,
    canActivate: [RoleGuard],
    data: { roles: [UserRole.Admin], allowBCUser: true },
  },
];
